<div class="card flex-between">
	<div class="left">
		<div class="circle"></div>
		<div>
			<div class="card-label">Online</div>
			<div class="card-label italic">{{ timeAgo }}</div>
		</div>
	</div>
	<div class="right">
		<div class="circle"></div>
		<div>
			<div class="card-label">{{ location }}</div>
			<div class="card-label italic">{{ timeAgo }}</div>
		</div>
	</div>
</div>
